<valg-dk-page-layout
  [election]="election"
  [links]="links"
  [filterLinks]="links"
  [sideNavTitleType]="sideNavTitleType"
  [parentLinkType]="parentLinkType">
  <valg-dk-breadcrumbs></valg-dk-breadcrumbs>
  <h1 class="h2 mt-0 mb-8 hyphenate">
    {{ 'page.election_overview.heading_with_date' | translate: {election: election?.electionName, date: ( election?.electionDate | date: 'longDate' )} }}
  </h1>
  <div class="row">
    <div class="col-12 col-lg-6 order-1 order-lg-1">

        <ng-container *ngTemplateOutlet="valgDkElectionMapCard; context: { isDesktopView: false }"></ng-container>

        <valg-card [border]="true" [custom]="true" class="p-0" height="492px">
          <valg-table
            [columnDefinition]="latestUpdatesMunicipalityColumnDef"
            [data]="lastestUpdates"
            [itemName]="'election_overview.latest_updates.table.item_name' | translate"
            [title]="'election_overview.latest_updates.title' | translate"
            [hasPagination]="false"
            [displayItemCount]="false"
            [hasMainActionButton]="false">
            <h2 class="m-0 text--f20 text--500">{{ 'election_overview.latest_updates.title' | translate }}</h2>
          </valg-table>
        </valg-card>
      </div>
      <div class="col-12 col-lg-6 order-2 order-lg-2">
        <ng-container *ngTemplateOutlet="valgDkElectionMapCard; context: { isDesktopView: true }"></ng-container>
      </div>
    </div>
  </valg-dk-page-layout>

<ng-template #valgDkElectionMapCard let-isDesktopView="isDesktopView">  
  <valg-card [ngClass]="isDesktopView ? 'd-none d-lg-block': 'd-lg-none'" [border]="true" [custom]="true" *ngIf="election?.isDisplayingMap && election">
    <h2 class="card-heading mb-0">{{ 'map.title.status_municipalities' | translate }}</h2>
    <valg-dk-election-map
      (areaClicked)="onAreaClick($event)"
      [electionYear]="election.electionYear"
      [electionType]="election.electionType"
      [mapAreasMapping]="mapAreasMapping">
    </valg-dk-election-map>
  </valg-card>
</ng-template>
